import React, { Component } from 'react'
import { connect } from 'react-redux'
import Dropzone from 'react-dropzone'
import { toast } from 'react-toastify'
import numeral from 'numeral'

import Modal from './Modal'
import ModalHeader from './ModalHeader'
import ModalButtonStrip from './ModalButtonStrip'
import ModalBody from './ModalBody'
import ModalFooter from './ModalFooter'
import BoxButton from '../Layout/BoxButton'



import {
	displayModalAddFile,
	getParameterByName,
	selectFile,
	updateInputs,
	addFile
} from '../../actions/common'


import { acceptedFiles } from '../../utils/helpers'


const filesTypes = acceptedFiles.map(x => x.type).join()


class ModalAddFile extends Component {
	handleCloseModal = (e) => {
		const modal = document.getElementById('modalAddFile')
		modal.classList.remove('fadeIn')
		modal.classList.add('fadeOut')

		const modalDialog = document.querySelector(`#modalAddFile .modal-dialog`)
		modalDialog.classList.remove('zoomIn')
		modalDialog.classList.add('zoomOut')

		setTimeout(() => this.props.displayModalAddFile(false), 300)
	}

    handleOnDrop = (files) => {
        if (files.length > 1) {
            toast.warn(`Solo es permitido procesar un archivo a la vez`, { bodyClassName: 'toastify-content toastify-warning' })
            return
        }
        this.props.selectFile(files[0])
    }

    handleOnRejected = (files) => {
        files.forEach(x => {
            toast.warn(`El archivo ${x.name} no es del tipo esperado. ${x.type}`, { bodyClassName: 'toastify-content toastify-warning' })
        })
    }

	setIcon = (icon) => {
		if (icon) {
			const imageSrc = require('../../img/16px/' + icon)
			return <img src={ imageSrc } />
		}
		return null
	}



	render() {

		const { modalAddFile } = this.props
		
		if (!modalAddFile.get('show')) {
			return null
		}


		let clasificacionArchivos = this.props.clasificacionArchivos ? this.props.clasificacionArchivos.toJS() : []

		return(
			<Modal id="modalAddFile" show={ true } zindex={ 2000 } width={ 600 } >
				<ModalHeader title={ modalAddFile.get('title') } onClose={ (e) => this.handleCloseModal(e) } />
				<ModalButtonStrip>
					<BoxButton name="check" disabled={ modalAddFile.get('btnDisabled') } title="Aceptar" onClick={ () => { this.props.action(); this.handleCloseModal() }} />
				</ModalButtonStrip>
				<ModalBody >
					<div>
						<div className="row">
							<div className="col-md-12">
                                <Dropzone accept={ filesTypes } onDropAccepted={ this.handleOnDrop } onDropRejected={ this.handleOnRejected } className="dropzone1">
                                    <p>Arrastre los archivos a esta sección</p>
                                </Dropzone>
							</div>
						</div>
						<div className="row" style={{ marginTop: '10px' }}>
							<div className="col-md-12">
								<div className="form-group">
									<label className="control-label">Nombre</label>
									<div className="div-input-sm">
										{
											(modalAddFile.getIn(['data', 'file']) &&
												<div style={{ paddingTop: '1px' }}>
													<span>{ this.setIcon(modalAddFile.getIn(['data', 'icono'])) }</span>
													<span style={{ marginLeft: '4px', verticalAlign: 'bottom' }}>{ modalAddFile.getIn(['data', 'file']).name }</span>
													<span style={{ marginLeft: '3px', verticalAlign: 'bottom', color: '#ccc' }}>({ numeral(modalAddFile.getIn(['data', 'file']).size).format('0.0 b') })</span>
												</div>
											)
										}
									</div>
								</div>
							</div>
						</div>
						<div className="row">
							<div className="col-md-12">
								<div className="form-group">
									<label className="control-label">Tipo</label>
									<select className="form-control input-sm" value={ modalAddFile.getIn(['data', 'clasificacion']) || '' } onChange={ (e) => this.props.updateInputs('modalAddFile.data.clasificacion', e.target.value) }>
										<option value >Seleccione un tipo</option>
										{
											clasificacionArchivos.sort((a, b) => { 
												if(a.CLASIFICACION < b.CLASIFICACION) return -1
												if(a.CLASIFICACION > b.CLASIFICACION) return 1
												return 0
											}).map((x, n) => {
												return (
													<option key={ `opt[0][${n}]` } value={ x.CLASIFICACION }>{ x.CLASIFICACION }</option>
												)
											})
										}
									</select>
								</div>
							</div>
						</div>
						<div className="row">
							<div className="col-md-12">
								<div className="form-group">
									<label className="control-label">Observaciones</label>
									<textarea className="form-control input-sm" value={  modalAddFile.getIn(['data', 'observaciones'])  } onChange={ (e) => this.props.updateInputs('modalAddFile.data.observaciones', e.target.value) } rows={ 3 } />
								</div>
							</div>
						</div>
					</div>
				</ModalBody >
				<ModalFooter >
				</ModalFooter>
			</Modal>
		)
	}
}

const mapStateToProps = (state, onwProps) => {
	return {
		modalAddFile: state.common.get('modalAddFile'),
		clasificacionArchivos: state.common.getIn(['parametros', 'CLASIFICACION_ARCHIVOS']),
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		getParameterByName: (name) => dispatch(getParameterByName(name)),
		selectFile: (file) => dispatch(selectFile(file)),
		updateInputs: (path, value) => dispatch(updateInputs(path, value)),
		addFile: (type) => dispatch(addFile(type)),
		displayModalAddFile: (show) => dispatch(displayModalAddFile(show)),
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalAddFile)



// WEBPACK FOOTER //
// ./src/components/Shared/ModalAddFile.jsx